export default function About() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Ethical Breeding Standards',
      description: 'Following best practices in responsible breeding'
    },
    {
      icon: 'ri-home-heart-line',
      title: '100% Indoor Raised',
      description: 'Safe, clean, and loving home environment'
    },
    {
      icon: 'ri-eye-line',
      title: 'Blue-Eyed Purebreds',
      description: 'Authentic Ragdoll characteristics'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Gentle, Calm Temperaments',
      description: 'Perfect companions for families'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Lifetime Support After Adoption',
      description: 'We\'re here for you and your kitten always'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">About Ragdoll Gentle Paws</h2>
          <div className="max-w-4xl mx-auto space-y-6 text-lg text-gray-700 leading-relaxed">
            <p>
              Ragdoll Gentle Paws Adoption is a dedicated home-based cattery focused on raising sweet, affectionate, purebred Ragdoll kittens.
            </p>
            <p>
              Our kittens are raised indoors in a calm and loving environment, exposed to family interaction and early social training.
            </p>
            <p>
              We prioritize health, temperament, and the gentle, relaxed nature Ragdolls are famous for.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mt-16">
          {values.map((value, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-all hover:-translate-y-1"
            >
              <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-blue-400 to-purple-300 rounded-full flex items-center justify-center">
                <i className={`${value.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
